import React, {Component, PropTypes} from 'react';


class Arrow extends Component {

  render() {
    let angle = '-135.000000';
    let {rotate, color = '#000000'} = this.props;

    if (rotate) {
      angle = '-45.000000';
    }

    return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17px" height="25px" viewBox="0 0 17 10" version="1.1">
      <title>Rectangle</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="---" transform="translate(-212.000000, -106.000000)" stroke={`${color}`} stroke-width="2.7">
          <polyline id="Rectangle" transform={`translate(220.500000, 107.500000) rotate(${angle}) translate(-220.500000, -107.500000)`} points="225 112 216 112 216 103"/>
        </g>
      </g>
    </svg>);
    }
}

export default Arrow;



// WEBPACK FOOTER //
// ./app/components/regionalization/Arrow.js